import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Pages from '../pages/allPages'
import Home from '../pages/home'
import Test from '../pages/test'
import Index from '../pages/index' //首页
import register from '../pages/register' //注册
import Login from '../pages/login' //登录
import Quotes from '../pages/quotes' //行情
import Qihuolist from '../pages/qihuolist' //期货列表
import Lang from '../pages/lang' //语言
import Info from '../pages/info' //币种详情
import Funds from '../pages/funds' //资金
import News from '../pages/news' //资讯
import ContractTrade from '../pages/contractTrade' //合约交易
import ContractPosition from '../pages/contractPosition' //持仓
import Authentication from '../pages/authentication' //身份认证
import ChangePassword from '../pages/changePassword'  //修改登录密码
import ChangeFundsPassword from '../pages/changeFundsPassword'//修改资金密码
import HelpCenter from '../pages/helpCenter'  //帮助中心
import HelpDetail from '../pages/helpDetail' //帮助中心详情
import AboutUs from '../pages/aboutUs'  //关于我们
import ShareQRcode from '../pages/shareQRcode' //分享二维码
import AccountChange from '../pages/accountChange' //账变记录
import RechargeType from '../pages/rechargeType' //选择充值类型
import Recharge from '../pages/recharge' //充值
import Withdraw from '../pages/withdraw' //提现
import Exchange from '../pages/exchange' //闪兑
import Chat from '../pages/chat'  //客服
import Promote from '../pages/promote'//推广记录
import MoneyLog from '../pages/moneyLog'  //充值提现记录
import Relogin from '../pages/relogin'//从新登录页
import My from '../pages/my' //我的页面
import AdvancedCtf from '../pages/advancedCtf'//高级认证页面
import Financial from '../pages/financial' //基金理财页面
import FinancialRule from '../pages/financialRule' //基金理财规则
import FinancialBuy from '../pages/financialBuy' //基金理财购买页面
import FinancialOrder from '../pages/financialOrder' //基金理财托管订单页面
import PerpetualHistory from '../pages/perpetualHistory' //U本位合约历史
import DeliveryContractHistory from '../pages/deliveryContractHistory' //交割合约历史
import AddPayment from '../pages/addPayment'  //添加收款方式
import Spot from '../pages/spot'  //现货交易
import NoticeList from '../pages/noticeList' //公告列表页面
import OrderDetail from '../pages/orderDetail'  //订单详情
import NoticeDetail from '../pages/noticeDetail' //公告详情
import Search from '../pages/search' //公告详情
import RechargeIframe from '../pages/rechargeIframe' //充值网站内嵌
import HoldPosition from '../pages/holdPosition'  //持有仓位
import NewDetail from '../pages/newDetail'  //资讯详情
import Forget from '../pages/forget'  //忘记密码
import HoldSpotPosition from '../pages/holdSpotPosition' //现货持仓
import Unit from '../pages/unit'  //计价方式
import Trade from '../pages/trade'  //交易页面
import Bank from '../pages/bank'  //银行提款

export default new Router({
    routes: [{
        path: '/',
        redirect: '/pages/home/quotes',
    }, {
        path: '/pages',
        component: Pages,
        children: [{
            path: '/pages/home',
            component: Home,
            children: [{
                path: '/pages/home/index',//首页
                component: Index
            },{
                path: '/pages/home/my',//我的
                component: My
            },{
                path: '/pages/home/funds',//资金
                component: Funds
            },{
                path: '/pages/home/news',//资讯
                component: News
            },{
                path: '/pages/home/quotes',//行情
                component: Quotes
            },{
                path: '/pages/home/trade',//交易
                component: ContractTrade
            }
          ]
        },
        {
            path: '/pages/futurelist',//期货列表
            component: Qihuolist
        },{
            path: '/pages/lang',//选择语言
            component: Lang
        },{
            path: '/pages/info',//币种详情
            component: Info
        },{
            path: '/pages/contractTrade',//合约交易
            component: ContractTrade
        },
        {
            path: '/pages/hold',//交易持仓
            component: ContractPosition
        },
        {
            path: '/pages/authentication',//身份认证
            component: Authentication
        },{
            path: '/pages/changePassword',//修改登录密码
            component: ChangePassword
        },{
            path: '/pages/changeFundsPassword',//修改资金密码
            component: ChangeFundsPassword
        },{
            path: '/pages/helpCenter',//帮助中心
            component: HelpCenter
        },{
            path: '/pages/helpDetail',//帮助中心详情
            component: HelpDetail
        },{
            path: '/pages/aboutUs',//关于我们
            component: AboutUs
        },{
            path: '/pages/shareQRcode',//分享二维码
            component: ShareQRcode
        },{
            path: '/pages/accountChange',//账变记录
            component: AccountChange
        },{
            path: '/pages/rechargeType',//选择充值类型
            component: RechargeType
        },{
            path: '/pages/recharge',//充值页面
            component: Recharge 
        },{
            path: '/pages/withdraw',//提现
            component: Withdraw 
        },{
            path: '/pages/exchange',//闪兑
            component: Exchange
        },{
            path: '/pages/register',//注册
            component: register 
        },{
            path: '/pages/chat',//客服
            component: Chat
        },{
            path: '/pages/promote',//推广记录
            component: Promote
        },{
            path: '/pages/moneyLog',//充值提现记录
            component: MoneyLog
        },{
            path: '/pages/login',//登录
            component: Login
        },{
            path: '/pages/relogin',//从新登录页面
            component: Relogin 
        },{
            path: '/pages/advancedCtf',//高级认证
            component: AdvancedCtf 
        },{
            path: '/pages/financial',//基金理财
            component: Financial 
        },{
            path: '/pages/financialRule',//基金理财规则页面
            component: FinancialRule 
        },{
            path: '/pages/financialBuy',//基金理财购买页面
            component: FinancialBuy 
        },{
            path: '/pages/financialOrder',//基金理财托管订单
            component: FinancialOrder 
        },{
            path: '/pages/perpetualHistory',//U本位合约历史
            component: PerpetualHistory 
        },{
            path: '/pages/deliveryContractHistory',//交割合约历史
            component: DeliveryContractHistory 
        },{
            path: '/pages/addPayment',//添加收款方式
            component: AddPayment 
        },{
            path: '/pages/spot',//现货交易
            component: Spot 
        },{
            path: '/pages/noticeList',//公告列表
            component: NoticeList
        },{
            path: '/pages/orderDetail',//订单详情
            component: OrderDetail
        },{
            path: '/pages/noticeDetail',//公告详情
            component: NoticeDetail
        },{
            path: '/pages/search',//搜索
            component: Search
        },{
            path: '/pages/rechargeIframe',//充值网站
            component: RechargeIframe
        },{
            path: '/pages/holdPosition',//持有仓位
            component: HoldPosition
        },{
            path: '/pages/newDetail',//咨询详情
            component: NewDetail
        },{
            path: '/pages/forget',//忘记密码
            component: Forget
        },{
            path: '/pages/holdSpotPosition',//现货持仓
            component: HoldSpotPosition
        },{
            path: '/pages/unit',//计价方式
            component: Unit
        },{
            path: '/pages/test',//测试
            component: Test
        },
        {
            path: '/pages/bank',//银行提款
            component: Bank
        },
        ]

        
        
        
        

    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js